module.exports = __webpack_public_path__ + "img/retour.24a5bde.png";